// components/LoginModalWrapper.js
import React, { createContext, useContext, useState } from 'react';
import LoginModal from '../components/LoginModal';

const LoginModalContext = createContext();

export const useLoginModal = () => useContext(LoginModalContext);

export const LoginModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openLoginModal = () => setIsOpen(true);
  const closeLoginModal = () => setIsOpen(false);

  return (
    <LoginModalContext.Provider value={{ openLoginModal, closeLoginModal }}>
      {children}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-[9999]">
          <LoginModal onClose={closeLoginModal} />
        </div>
      )}
    </LoginModalContext.Provider>
  );
};
